import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4a295fce"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 报名 ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_MeetingDetail = _resolveComponent("MeetingDetail");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "线下会议",
    back: true
  }), _createVNode(_component_MeetingDetail, {
    detail: _ctx.detail,
    "show-attachment": _ctx.showAttachment,
    onDownFile: _ctx.downFile
  }, {
    other: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "more"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(function () {
              return [_hoisted_1, _createVNode(_component_el_button, {
                size: "medium",
                type: "primary",
                class: "btnSign",
                onClick: _ctx.handleAudit
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(" 还剩   " + _toDisplayString(_ctx.count) + "人   去报名 ", 1)];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["detail", "show-attachment", "onDownFile"])], 64);
}